import React, {useState} from "react"
import {SignUpFormViewModel} from "./sign-up-form-viewmodel"
import {useServices} from "../../services/services"
import {SignUpForm} from "./sign-up-form"
import {ValidationError} from "../../services/api/models/validation-error"
import {ValidationErrorDuplicateUserName, ValidationErrorPasswordTooShort} from "../../services/api/registration-api"

export const SignUp: React.FC = () => {
  const services = useServices()
  const [hasRegistered, setHasRegistered] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const signUp = async (signUpForm: SignUpFormViewModel) => {
    if (services === null) return

    try {
      await services.registrationApi.registerUser(signUpForm.email, signUpForm.password)
      setHasRegistered(true)
    } catch (err) {
      if (err instanceof ValidationError) {
        if (err.code === ValidationErrorPasswordTooShort) {
          setError("Het wachtwoord dient tenminste 8 tekens lang te zijn")
          return
        }
        else if (err.code === ValidationErrorDuplicateUserName) {
          setError("Er bestaat al een account voor dit emailadres")
          return
        }
      }
      setError("Er is iets misgegaan bij het maken van je account. Probeer het later opnieuw.")
    }
  }

  if (hasRegistered) {
    return <>
      Je account is succesvol aangemaakt. Je ontvangt binnen enkele minuten een email met een link om je account te bevestigen.
    </>
  }

  return <SignUpForm onSubmit={signUp} validationError={error} />
}